import React from 'react';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import Button from '../Form/Button';
import { TbUserQuestion } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import ButtonPrimary from '../Form/ButtonPrimary';
import { useLoginHook } from '../../Hooks/LoginHook';

interface ButtonLoginSSOProps {
    className?: string;
    asButtonGray?: boolean;
    hasLinkIcon?: boolean;
    labelLink?: string;
    iconSize?: number;
}

const ButtonLoginSSO = ({
    className,
    asButtonGray = false,
    hasLinkIcon = false,
    labelLink,
    iconSize = undefined,

}: ButtonLoginSSOProps) => {

    const { t } = useTranslation();
    const { company } = useLayoutContext();
    const { handleRedirectSSO } = useLoginHook();

    const handleClickSSO = () => {
        handleRedirectSSO();
    }

    if (!company || !company.sso_active) return null;

        if (asButtonGray) {
            return (
                <Button
                    gray
                    withLoading
                    onClick={handleClickSSO} className={`gap-1 ${className}`}
                    >
                    {hasLinkIcon && <TbUserQuestion size={iconSize} />}
                    {labelLink ?? t('login.label_button_sso')}
                </Button>
            )
        } else {
            return (
                <ButtonPrimary
                    onClick={handleClickSSO} 
                    withLoading={true}
                    className={`
                        relative justify-center items-center
                        min-h-max
                        flex gap-3
                        ${className}
                    `}
                >
                    <span className="flex items-center gap-1 leading-none">
                        <div><TbUserQuestion size={iconSize} /></div><div>{t('login.label_button_sso')}</div>
                    </span>
                </ButtonPrimary>
            )
        }
}

export default ButtonLoginSSO;